import { svg } from '@rxdi/lit-html';

export const Logo = svg`
<svg
 viewBox="0 0 485.878 485.878"
 style="enable-background: new 0 0 485.878 485.878;"
 xml:space="preserve"
>
 <g>
  <rect
   x="99.292"
   y="215.26"
   transform="matrix(-0.8321 -0.5547 0.5547 -0.8321 59.9275 561.5178)"
   style="fill: #1185e0;"
   width="31.348"
   height="112.854"
  />

  <rect
   x="184.422"
   y="242.935"
   transform="matrix(-0.7682 -0.6402 0.6402 -0.7682 268.6176 614.4741)"
   style="fill: #1185e0;"
   width="122.252"
   height="31.347"
  />

  <rect
   x="355.789"
   y="158.847"
   transform="matrix(-0.8842 -0.4672 0.4672 -0.8842 593.8322 601.3008)"
   style="fill: #1185e0;"
   width="31.348"
   height="136.365"
  />
 </g>
 <g>
  <path
   style="fill: #4dcfe0;"
   d="M62.694,423.184C28.212,423.184,0,394.971,0,360.49s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S97.176,423.184,62.694,423.184z M62.694,329.143c-17.241,0-31.347,14.106-31.347,31.347
		c0,17.241,14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347C94.041,343.249,79.935,329.143,62.694,329.143z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M167.184,245.551c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S201.665,245.551,167.184,245.551z M167.184,151.51c-17.241,0-31.347,14.106-31.347,31.347
		s14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347S184.424,151.51,167.184,151.51z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M323.918,397.061c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S358.4,397.061,323.918,397.061z M323.918,303.02c-17.241,0-31.347,14.106-31.347,31.347
		c0,17.241,14.106,31.347,31.347,31.347s31.347-14.106,31.347-31.347S341.159,303.02,323.918,303.02z"
  />
  <path
   style="fill: #4dcfe0;"
   d="M423.184,188.082c-34.482,0-62.694-28.212-62.694-62.694s28.212-62.694,62.694-62.694
		s62.694,28.212,62.694,62.694S457.665,188.082,423.184,188.082z M423.184,94.041c-17.241,0-31.347,14.106-31.347,31.347
		s14.106,31.347,31.347,31.347c17.241,0,31.347-14.106,31.347-31.347S440.424,94.041,423.184,94.041z"
  />
 </g>
</svg>
`;
